package app.nestbridge.feature.invitations.ui

import app.nestbridge.feature.invitations.screen.InvitationOtpVerificationScreen
import com.karawek.core.auth.screen.OtpVerificationState
import com.slack.circuit.runtime.CircuitContext
import com.slack.circuit.runtime.screen.Screen
import com.slack.circuit.runtime.ui.Ui
import com.slack.circuit.runtime.ui.ui
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding

@Inject
@ContributesBinding(
  AppScope::class,
  multibinding = true,
)
public class InvitationOtpVerificationUiFactory : Ui.Factory {
  override fun create(screen: Screen, context: CircuitContext): Ui<*>? = when (screen) {
    is InvitationOtpVerificationScreen -> ui<OtpVerificationState> { state, modifier -> InvitationOtpVerificationUi(state = state, modifier = modifier) }
    else -> null
  }
}
